import { BrowserRouter as Router, Switch} from 'react-router-dom';
import HomeTwo from './pages/homes/HomeTwo';
import Contact from './pages/contact/Contact';
import Community from './pages/community/Community';
import AboutUs from './pages/aboutpage/aboutuspage/AboutUs';
import ScrollToTopRoute from './components/scrolltotop/ScrollToTopRoute';

import {useEffect} from "react";

function App() {
   useEffect(()=>{
         window.addEventListener('load', function(){
            document.querySelector('body').setAttribute('style','display: block;')
         })
   },[])
  
  return (
    
    <div className="App">
      
     <Router>
        <Switch>

           <ScrollToTopRoute exact={true} path='/'>
             <HomeTwo/>
           </ScrollToTopRoute>

           <ScrollToTopRoute exact={true} path='/contact'>
              <Contact/>
           </ScrollToTopRoute>

           <ScrollToTopRoute exact={true} path='/team-members'>
               <Community/>
           </ScrollToTopRoute>

           <ScrollToTopRoute exact={true} path='/about-us'>
              <AboutUs/>
           </ScrollToTopRoute>

        </Switch>
     </Router>

    </div>
  );
}

export default App;
